import React, {useState, useEffect, useRef} from 'react'
import firebase from './../../config/fbConfig.js'
import './feed.css';
import axios from 'axios'
import { Link } from 'react-router-dom'
import messageNum from './../assets/messages.png'
import noProfile from './../assets/noprofile.png'
import xButton from './../assets/xButton.png'
import like from './../assets/like.png'
import loadingGif from './../assets/loadingGif.gif'
import rightButton from './../assets/rightButton.png'
import ExtraOptions from './../extraOptions/extraOptions.js';


const db = firebase.firestore();

/* db.collection("feed").orderBy("timestamp", "desc").onSnapshot(snapshot => {   */
function Feed(props) {
	// state for the pic file, selectedpicture = the file, namePic = the name of the pic
	const [selectedPicture, setPic] = useState(null)
	const [namePic, setNamePic] = useState(false)
	let [feed, setFeed] = useState([])
	const [myProfile, setProfile] = useState({})
	const forceUpdate = React.useState()[1].bind(null, {})
	const loadingAnim = useRef(null)

	useEffect(() => {
		// get all documents, then iterate them to create the feed, feeds doc structure is: feed -> date -> pic, useruid, likes, rate, timestamp
		db.collection("feed").orderBy("timestamp", "desc").limit(25).get().then((querySnapshot) =>{
			for (let i = 0; i < querySnapshot.docs.length; i++) {
				db.collection("feed").doc(querySnapshot.docs[i].id).get().then((doc) => {

				feed = [...feed, {
					userID: doc.data().userID,
					title: doc.data().title,
					desc: doc.data().desc,
					delete: doc.data().delete,
					link: doc.data().link,
					likes: doc.data().likes,
					timestamp: doc.data().timestamp,
					dateFormat: doc.data().dateFormat,
					comments: doc.data().comments,
					commentsLength: doc.data().comments.length}]
					// On the last run, re-render the component
					if (i==querySnapshot.docs.length-1) {
						let copyFeed = [];

						let index = 0;
					    if (feed.length) {
					        next();
					    }

						// This function is used to make sure the next AJAX call will be as fast as the first AJAX, which means it's sequential as required 
					    function next() {
							// AJAX call to get nickname and profile picture for each post, individually according to the user's id
							db.collection("accounts").doc(feed[index].userID).get().then((doc) => {
									if (index==0) {									
										copyFeed = [{...feed[index], nickname: doc.data().nickname, picture: doc.data().pic, countryIMG: doc.data().countryIMG}];						
									} else {
										copyFeed = [...copyFeed , {...feed[index], nickname: doc.data().nickname, picture: doc.data().pic, countryIMG: doc.data().countryIMG}];				
									}
									 if (++index < feed.length) {
							                next();
							            }
						            // If this is the end of the array
							         if (index == feed.length) {
							         	feed = copyFeed;
							         	setFeed(feed);
							         	document.getElementById('LoadingFeed').hidden = true;
							         	document.getElementById('feed').hidden = false;
							         	document.getElementById('fakeNav').hidden = true;
							         	// When this isn't a phone
							         	if(!props.isPhone.current && document.body.scrollHeight > window.innerHeight) {
										 	document.getElementById('menu').style.right = '25px';
										}									
							         }
						  		});
							}
					}
				});
			}
		})
	}, [])

	let createPost = () => {
		document.getElementById('SendPost').hidden = false;
		let darkness = document.createElement('div');
		darkness.style.position = 'fixed';
		darkness.style.top = '0';
		darkness.style.width = '100vw';
		darkness.style.height = '100vh';
		darkness.style.backgroundColor = 'black';
		darkness.style.opacity = '0.6';
		darkness.style.zIndex = '99999';
		darkness.id = "darkness";
		const feed = document.getElementById('feed');
		feed.append(darkness);
		document.body.style.overflow = 'hidden';
	}

	let closeNewPost = () => {
		let darkness = document.getElementById('darkness');
		darkness.remove();
		document.getElementById('SendPost').hidden = true;
		document.body.style.overflow = 'visible';
		setNamePic(null);
	}

	let GeneratePic = (e) => {
		setPic(e.target.files[0]);
		setNamePic(e.target.files[0].name);
	}
	let focusNewPost = (e) => {
		e.target.parentNode.style.boxShadow = '-10px 0px 20px 0px white';
	}
	let unFocusNewPost = (e) => {
		e.target.parentNode.style.boxShadow = 'none';
	}

	let UploadPost = (e) => {
		 if (selectedPicture==null) {
		 	alert(`You haven't uploaded any picture yet.`);
		 	return;
		 }
		 if (document.forms.SendPost.title.value == "") {
		 	return;
		 }
		 if (document.forms.SendPost.title.value>20) {
		 	alert(`You can't enter more than 20 characters in title`)
		 	return;
		 }
		 
		 // Only image pics are allowed
		 if (selectedPicture.type.match(/image/) && selectedPicture.type !== 'image/svg+xml') {
 	
		 	const loading = e.target.nextSibling;
		 	loading.hidden = false;
		 	let UpOrDown = 0;
		 	loadingAnim.current = window.setInterval(() => {
				if (UpOrDown==0) {
					loading.innerHTML += ".";
					if (loading.innerHTML=="Loading....") {
						UpOrDown = 1;
					}
				} else {
					loading.innerHTML = loading.innerHTML.slice(0, loading.innerHTML.length-1); // Removing last letter every 300ms until "Loading"
					if (loading.innerHTML=="Loading") {
						UpOrDown = 0;
					} 
				}
			}, 300);
		 	
		 	
		 	let fd = new FormData();
		 	fd.append('image', selectedPicture);

		 	const options = {
			  headers: {'Authorization': 'Client-ID 805e6c0b10879f4'}		  
			};
			
			axios.post('https://api.imgur.com/3/image', fd, options).then(response => {
		
				let link = response.data.data.link;
				let remove = response.data.data.deletehash;
				db.collection("feed").doc(props.user.uid).get().then((doc) => {
			        const title = document.forms.SendPost.title.value;

					// get current timestamp
					let timeNow = firebase.firestore.Timestamp.fromDate(new Date()).seconds;

					let dateFormat = new Date(timeNow*1000);

					let firstPart = dateFormat.toLocaleDateString("en-GB");

					let hours = "";
					let minutes = "";
					if (dateFormat.getHours()<10) {
					  	hours = "0" + dateFormat.getHours();
					} else { hours = dateFormat.getHours();	}

					if (dateFormat.getMinutes()<10) {
					  	minutes = "0" + dateFormat.getMinutes();
					} else { minutes = dateFormat.getMinutes();	}

					dateFormat = `${firstPart} ${hours}:${minutes}`;
	
					// Because firebase needs a String and not a number
					timeNow = timeNow.toString();

					// This is adding the picture to the feed document
					db.collection("feed").doc(timeNow).set({
							dateFormat: dateFormat,
							timestamp: timeNow,
							comments: [],
				        	userID: props.user.uid,
				        	title: title,
				        	desc: (document.forms.SendPost.desc.value!="") ? document.forms.SendPost.desc.value : false,
				        	likes: [0],
				        	link: link,
				        	delete: remove
			        });

					db.collection('album').doc(props.user.uid).collection('album').doc(timeNow).set({
						dateFormat: dateFormat,
						timestamp: timeNow,
						comments: [],
			        	title: title,
			        	desc: (document.forms.SendPost.desc.value!="") ? document.forms.SendPost.desc.value : false,
			        	likes: [0],
			        	link: link,
			        	delete: remove
					});
					
			        alert('Successfully Uploaded');
			        setTimeout(() => window.location.reload(), 500);
			        clearInterval(loadingAnim.current);
			        
					}).catch(function(error) {
					    console.log("Error getting document:", error);
					});
			})
			.catch(err => {
				alert("There was an error. It could be that your picture isn't an image.")
			})
			
		 } else {
		 	alert("Hey the file you uploaded isn't a picture")
		 }

	}

	// This useEffect t is used to generate nickname, countryIMG, profilePic of the logged user in order to show them while making a comment
	useEffect(() => {
		if (props.user!=null) {
			db.collection("accounts").doc(props.user.uid).get().then((doc) => {
				setProfile({
					nickname: doc.data().nickname,
					countryIMG: doc.data().countryIMG,
					profilePic: doc.data().pic
				})
			})
		}
	}, [props.user])

	let addComment = (e) => {
		// Enable border bottom for the specific post
		e.target.parentNode.parentNode.children[0].style.borderBottom = '5px solid black';
		// Unhide the personal comment option
		e.target.parentNode.nextSibling.children[0].hidden = false;
		// Hide the 'add comment' button
		e.target.hidden = true;
	}

	let sendComment = (e) => {
		let targ;
		if (e.target.tagName=="IMG") {
			targ = e.target.parentNode
		} else {
			targ = e.target;
		}
		
		if (targ.previousSibling.value=="") {
			alert("You didn't enter anything.")
			return;
		}
		const specificPost = targ.parentNode.parentNode.parentNode.children[0].dataset.time;
		const postCreatorID = targ.parentNode.parentNode.parentNode.children[0].dataset.id;

		// Get current time's format
		let timeNow = firebase.firestore.Timestamp.fromDate(new Date()).seconds;
		let dateFormat = new Date(timeNow*1000);
		let firstPart = dateFormat.toLocaleDateString("en-GB");
		let hours = "";
		let minutes = "";

		if (dateFormat.getHours()<10) {
		  	hours = "0" + dateFormat.getHours();
		} else { hours = dateFormat.getHours();	}
		if (dateFormat.getMinutes()<10) {
		  	minutes = "0" + dateFormat.getMinutes();
		} else { minutes = dateFormat.getMinutes();	}

		dateFormat = `${firstPart} ${hours}:${minutes}`;

		if (targ.previousSibling.value.length < 4) {
			alert('You need to enter at least 4 characters for a message.')
			return;
		} else {
			let deliveredComment = {
				userID: props.user.uid,
				dateFormat: dateFormat,
				nickname: myProfile.nickname,
				profilePic: myProfile.profilePic!=undefined ? myProfile.profilePic : 'https://i.imgur.com/pDcFnDX.png',
				countryIMG: myProfile.countryIMG,
				data: targ.previousSibling.value
			}
			
			let index = feed.findIndex(i => i.timestamp === specificPost);
			feed[index].comments.push(deliveredComment);
			feed[index].commentsLength = feed[index].comments.length;
			setFeed(feed);
			forceUpdate();

			// Inject the comment inside the feed's specific post document
			db.collection('feed').doc(specificPost).update({
				comments: firebase.firestore.FieldValue.arrayUnion(deliveredComment)
			});

			// Inject the comment inside the private album's feed
			db.collection("album").doc(postCreatorID).collection('album').doc(specificPost).update({
				comments: firebase.firestore.FieldValue.arrayUnion(deliveredComment)
			});		

			// Hiding the line of adding a element
			targ.parentNode.hidden = true;
			// Unhiding the other comments element
			targ.parentNode.nextSibling.hidden = false;
			// Removing the border bottom for the specific LI
			targ.parentNode.parentNode.previousSibling.style.borderBottom = "none";
			// Unhiding the button of add a comment
			targ.parentNode.parentNode.previousSibling.lastChild.hidden = false;
			// Retriveing border bottom right to 0 for both buttons
			targ.parentNode.parentNode.previousSibling.lastChild.style.borderBottomRightRadius = "0";
			targ.style.borderBottomRightRadius = "0";

		}
		
	}

	let getComments = (e) => {
		// Onclick toggle the other comments section visiblity, relatively for the clicked item(div/span/img)
		if (e.target.tagName=='DIV') {
			if (e.target.children[0].innerHTML==0) return;
			if (e.target.parentNode.nextSibling.children[1].hidden && props.user!=null) e.target.parentNode.nextSibling.children[0].lastChild.style.borderBottomRightRadius = "0";
			e.target.parentNode.nextSibling.children[1].hidden = !(e.target.parentNode.nextSibling.children[1].hidden);
			// Changing 'add a comment button' radius onclick
			if (!e.target.parentNode.nextSibling.children[1].hidden && props.user!=null) e.target.nextSibling.style.borderBottomRightRadius = "0";
			if (e.target.parentNode.nextSibling.children[1].hidden && props.user!=null) e.target.nextSibling.style.borderBottomRightRadius = "15px";
			// Changing height of the UL comments because the overflow(scroll bar) should show only in case of certain height
			if (e.target.parentNode.nextSibling.children[1].firstChild.offsetHeight>window.innerHeight/3.3) {
				e.target.parentNode.nextSibling.children[1].firstChild.style.height = '30vh';
			} else {
				e.target.parentNode.nextSibling.children[1].firstChild.style.height = 'auto';
			}
		}

		if (e.target.tagName=='IMG' || e.target.tagName=='SPAN') {
			if (e.target.parentNode.children[0].innerHTML==0) return;
			if (e.target.parentNode.parentNode.nextSibling.children[1].hidden && props.user!=null) e.target.parentNode.parentNode.nextSibling.children[0].lastChild.style.borderBottomRightRadius = "0";
			e.target.parentNode.parentNode.nextSibling.children[1].hidden = !(e.target.parentNode.parentNode.nextSibling.children[1].hidden);
			// Changing 'add a comment button' radius onclick
			if (!e.target.parentNode.parentNode.nextSibling.children[1].hidden && props.user!=null) e.target.parentNode.nextSibling.style.borderBottomRightRadius = "0";
			if (e.target.parentNode.parentNode.nextSibling.children[1].hidden && props.user!=null) e.target.parentNode.nextSibling.style.borderBottomRightRadius = "15px";
			// Changing height of the UL comments because the overflow(scroll bar) should show only in case of certain height
			if (e.target.parentNode.parentNode.nextSibling.children[1].firstChild.offsetHeight>window.innerHeight/3.3) {
				e.target.parentNode.parentNode.nextSibling.children[1].firstChild.style.height = '30vh';
			} else {
				e.target.parentNode.parentNode.nextSibling.children[1].firstChild.style.height = 'auto';
			}
		}

	} 

	let LikeFunction = (e) => {
		if (props.user==null) {
			alert("You must be signed in to use this feature.")
			return;
		}
		let specificPost;
		let postCreatorID;
		if (e.target.tagName=='DIV') {
			specificPost = e.target.parentNode.parentNode.children[0].dataset.time;
			postCreatorID = e.target.parentNode.parentNode.children[0].dataset.id;

		}
		if (e.target.tagName=='SPAN' || e.target.tagName=='IMG') {
			specificPost = e.target.parentNode.parentNode.parentNode.children[0].dataset.time;
			postCreatorID = e.target.parentNode.parentNode.parentNode.children[0].dataset.id;
			
		}

		db.collection("feed").doc(specificPost).get().then((doc) => {
			// This index is used to make if the user already liked the post or not, -1 = didn't like
			let index = doc.data().likes.findIndex(i => i.userID === props.user.uid);

			// In case the like isn't in the list(-1 = not found), so need to increment the likes
			if (index == -1) {
				let arr = doc.data().likes;
				arr[0]++;
				arr.push({profilePic: myProfile.profilePic!=undefined ? myProfile.profilePic : 'https://i.imgur.com/pDcFnDX.png', nickname: myProfile.nickname, userID: props.user.uid});
				db.collection("feed").doc(specificPost).update({likes: arr});
				db.collection("album").doc(postCreatorID).collection("album").doc(specificPost).update({likes: arr});

				// This index is used to find the specific post in the feed in order to update it later
				let indexFeed = feed.findIndex(i => i.timestamp === specificPost);
				feed[indexFeed] = {...feed[indexFeed], likes: arr};
				setFeed(feed);

				forceUpdate();
			} else {
				// This means it was found that the user already liked this post, so decrementing the likes
				let arr = doc.data().likes;
				arr[0]--;
				arr.splice(index, 1);
				db.collection("feed").doc(specificPost).update({likes: arr});
				db.collection("album").doc(postCreatorID).collection("album").doc(specificPost).update({likes: arr});

				// This index is used to find the specific post in the feed in order to update it later
				let indexFeed = feed.findIndex(i => i.timestamp === specificPost);
				feed[indexFeed] = {...feed[indexFeed], likes: arr};
				setFeed(feed);

				forceUpdate();
			}
		})

	}
	
	return (
		<React.Fragment>

		<div id="fakeNav"></div>

		<div id="LoadingFeed">
		<img src={loadingGif}/>
		<div id="text">Loading</div>
		</div>

		<div id="feed" hidden>
			<h1>Welcome to feed</h1>

			{props.user!=null ? <button id="createPost" onClick={createPost}>Add a new post</button> : 
			<div id="createPost" style={{borderBottom: '4px solid black', borderRight: '4px solid black', borderBottomRightRadius: '30px'}}>You're not allowed to make posts.<Link to={'/login'}><div style={{marginTop: '5px'}}><b>Click here to register</b></div></Link></div>}

			<form id="SendPost" hidden onSubmit={(e) => e.preventDefault()}>
				<img src={xButton} id="closeNewPost" onClick={closeNewPost}/>
				<div className="field">
				 	<label htmlFor="title">Title</label>
	  				<input type="text" id="title" name="title" required autoComplete="off" onFocus={focusNewPost} onBlur={unFocusNewPost}/><br/>
				</div>
				
				<div className="field">
					<label htmlFor="desc">Description</label>
	  				<textarea type="text" id="desc" name="desc" onFocus={focusNewPost} onBlur={unFocusNewPost}/><br/>
  				</div>

				<label htmlFor="file-upload" id="labelUpload">
					
				    Upload a new picture
					{namePic && <div id="namePic"> |{namePic}|</div>}
					<input id="file-upload" type="file" onChange={GeneratePic}/>
				<button onClick={UploadPost}>Upload Post!</button>
				<div style={{color: 'beige'}} hidden>Loading</div>
				 </label>
			</form>

			<ul id="posts">
			{feed.map(post =>
				<div className="specificPost" key={post.timestamp}>

				<li key={post.timestamp} data-time={post.timestamp} data-id={post.userID}>

				<div className="frame">
					<span className="helper"></span><img src={post.link} alt="Post"/>
					<ExtraOptions likesLength={post.likes.length} postLikes={post.likes} isPhone={props.isPhone} user={props.user} userID={post.userID} forceUpdate={forceUpdate} feed={feed} setFeed={setFeed}/>
				</div>


				<div className="title">
					<h2>
						{post.picture!=undefined ? <img src={post.picture} alt="Profile pic"/> : <img src={noProfile} alt="no profile"/>}
						<img className="countryIMG" src={post.countryIMG} alt="Country"/>

						<span style={{alignSelf: 'center'}}>
						<u style={{marginRight: '10px', marginLeft: '10px'}}>
						<Link to={'/profile/' + post.userID} onClick={() => setTimeout(() => window.location.reload(), 0)}>{post.nickname}</Link>:</u>{post.title}
						<h6>{post.dateFormat}</h6>
						</span>
					</h2>				
				</div>

				<div className="desc">{post.desc}</div>

				<div className="likesLength" onClick={LikeFunction}><span>{post.likes[0]}</span><img src={like} alt="Like"/></div>
				<div className="commentsLength" onClick={getComments}><span>{post.commentsLength}</span> <img src={messageNum} alt="messages"/></div>
				{props.user!=null && <button onClick={addComment}>Add a comment</button>}

				</li>

				<div className="comments">
					<div className="yourComment" hidden>
						{myProfile.profilePic!=null ? <img className="profile" src={myProfile.profilePic} alt="Profile Pic"/> : <img className="profile" src={noProfile} alt="no profile"/>}
						<div className="nick">{myProfile.nickname}
						<img className="country" src={myProfile.countryIMG} alt="Country"/>
						</div>
						<textarea placeholder="Enter your comment here"/>
						{props.isPhone.current ? <button onMouseEnter={sendComment}><img src={rightButton} alt="->" style={{width: '25px'}}/></button> :
						<button onClick={sendComment}><img src={rightButton} alt="->" style={{width: '25px'}}/></button>}
					</div>

					<div className="otherComments" hidden>
						<ul>
							{post.comments!=null && post.comments.map((comment, index) => 
								<li key={index}>
									{/* need to add {comment.userID} for profile click later*/}
									{(comment.profilePic!=false) ? <img className="profile" src={comment.profilePic} alt="Profile Pic"/> :  <img className="profile" src={noProfile} alt="no profile"/>} 
									<div className="nick"><Link to={'/profile/' + comment.userID} onClick={() => setTimeout(() => window.location.reload(), 0)}>{comment.nickname}</Link>
									<img className="country" src={comment.countryIMG} alt="Country" style={{maxHeight: 'initial'}}/>
									</div>
									<div className="text">{comment.data}</div>
									<div className="timeComment">{comment.dateFormat}</div>
								</li>
							)}
						</ul>
					</div>

				</div>

				</div>
				)}

			</ul>

		</div>
		</React.Fragment>
	)
}

export default Feed